// import React, { useState, useContext, useRef, useEffect } from "react";
// import CheckoutContext from "../contexts/CheckoutContext";
// import { useNavigate } from "react-router-dom";
// import DeliveryForm from "./DeliveryForm";


// function DeliveryMemoryForm (props) {

//     const navigate = useNavigate();
//     const directionFormRef = useRef(null);

//     const { setDeliveryDirection } = useContext(CheckoutContext);

//     const [useOtherAddress, setUseOtherAddress] = useState(false);
//     const [isAddressSelected, setIsAddressSelected] = useState(false);

//     function handleAddressSelection(value) {
//         if (value === "other") {
//             setUseOtherAddress(true);
//         } else {
//             setUseOtherAddress(false);
//             for (let i = 0; i < props.previousPurchases.length; i++) {
//                 if (props.previousPurchases[i].address.id === value) {
//                     const data = {
//                         streetName: props.previousPurchases[i].address.streetName,
//                         streetNumber: props.previousPurchases[i].address.streetNumber,
//                         commune: props.previousPurchases[i].address.commune,
//                         city: props.previousPurchases[i].address.city,
//                         departmentNumber: props.previousPurchases[i].address.departmentNumber,
//                         houseNumber: props.previousPurchases[i].address.houseNumber,
//                     };
//                     setDeliveryDirection(data);
//                 }
//             }
//             setIsAddressSelected(true);
//         }
//     }



//     function handleClickContinue (e) {
//         e.preventDefault();
//         navigate("/checkout/info");
//     };

//     useEffect(() => {
//         if (useOtherAddress) {
//             directionFormRef.current.scrollIntoView({ behavior: "smooth" });
//         }
//     } ,[useOtherAddress]);

//     return (
//         <div className="mt-4">
//           <div className="shadow-xl mx-2 overflow-hidden">
//             <div className="font-bold text-2xl px-4 text-center text-gray-600 mt-2">
//               <p>Seleccione Direccion de Despacho</p>
//             </div>
//             <div className="text-left mx-2 px-2 text-gray-600">
//               <div className="mt-2 rounded-xl py-1">
//                 <div className="mx-2">
//                   <p>Direcciones de despacho usadas anteriormente:</p>
//                 </div>
//                 <div className="ml-4 mr-2">
//                 {props.previousPurchases.map((purchase) => (
//                   <div key={purchase.address.id} className="mt-2 flex">
//                     <input
//                       type="radio"
//                       id={purchase.address.id}
//                       name="selected_address"
//                       value={purchase.address.id}
//                       onChange={() => handleAddressSelection(purchase.address.id)}
//                       className="mr-2"
//                     />
//                     <label htmlFor={purchase.address.id} className="pl-1">
//                       {purchase.address.streetName} {purchase.address.streetNumber}, {purchase.address.commune}
//                       { (purchase.address.houseNumber.length > 0) ? ` (Casa: ${purchase.address.houseNumber})` : null}
//                       { (purchase.address.departmentNumber.length > 0) ? ` (Dpto: ${purchase.address.departmentNumber})` : null}
//                     </label>
//                   </div>
//                 ))}
//                 </div>
//               </div>

//               <div key="other" className="my-2">
//                 <input
//                   type="radio"
//                   id="other"
//                   name="selected_address"
//                   value="other"
//                   onChange={() => handleAddressSelection("other")}
//                   className="mr-2"
//                 />
//                 <label htmlFor="other">Usar otra dirección</label>
//               </div>
//             </div>
//           </div>
//           <div className="mt-4">
//             {useOtherAddress ? null : (
//               <div className="mx-2">
//                 <button
//                   onClick={handleClickContinue}
//                   className="h-10 bg-gray-700 hover:bg-gray-900 disabled:bg-gray-300 w-full text-white font-bold"
//                   disabled={!isAddressSelected}
//                 >
//                   Continuar
//                 </button>
//               </div>
//             )}
//             {useOtherAddress && <div ref={directionFormRef}><DeliveryForm/></div>}
//           </div>
//         </div>
//       );
// }

// export default DeliveryMemoryForm;



import React, { useState, useContext, useRef, useEffect } from "react";
import CheckoutContext from "../contexts/CheckoutContext";
import { useNavigate } from "react-router-dom";
import DeliveryForm from "./DeliveryForm";

function DeliveryMemoryForm(props) {

    const navigate = useNavigate();
    const directionFormRef = useRef(null);
    const { setDeliveryDirection } = useContext(CheckoutContext);

    const [useOtherAddress, setUseOtherAddress] = useState(false);
    const [isAddressSelected, setIsAddressSelected] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    function handleAddressSelection(value) {
        if (value === "other") {
            setUseOtherAddress(true);
            setIsAddressSelected(false);
            setSelectedId(null);
        } else {
            setUseOtherAddress(false);
            setSelectedId(value);
            for (let i = 0; i < props.previousPurchases.length; i++) {
                if (props.previousPurchases[i].address.id === value) {
                    const { streetName, streetNumber, commune, city, departmentNumber, houseNumber } = props.previousPurchases[i].address;
                    setDeliveryDirection({ streetName, streetNumber, commune, city, departmentNumber, houseNumber });
                }
            }
            setIsAddressSelected(true);
        }
    }

    function handleClickContinue(e) {
        e.preventDefault();
        navigate("/checkout/info");
    }

    useEffect(() => {
        if (useOtherAddress) {
            directionFormRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [useOtherAddress]);

    // Deduplica direcciones por id
    const uniqueAddresses = props.previousPurchases.filter(
        (p, i, arr) => arr.findIndex(x => x.address.id === p.address.id) === i
    );

    return (
        <div className="mt-4">

            {/* Card de selección */}
            <div className="mx-3 bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">

                {/* Header */}
                <div className="px-4 py-3 bg-[#f6f6ee] border-b border-gray-100 flex items-center gap-2">
                    <svg className="w-4 h-4 text-[#4a7c2f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
                    </svg>
                    <p className="text-sm font-semibold text-[#1e2a1a]">Dirección de despacho</p>
                </div>

                <div className="px-4 py-3 flex flex-col gap-1">
                    <p className="text-[12px] text-gray-400 mb-2">Direcciones usadas anteriormente</p>

                    {/* Direcciones previas */}
                    {uniqueAddresses.map((purchase) => {
                        const a = purchase.address;
                        const isSelected = selectedId === a.id;
                        return (
                            <label
                                key={a.id}
                                htmlFor={a.id}
                                className={`
                                    flex items-start gap-3 px-3 py-3 rounded-xl cursor-pointer transition-all border
                                    ${isSelected
                                        ? "border-[#4a7c2f] bg-[#edf4e0]"
                                        : "border-gray-100 bg-gray-50 active:bg-gray-100"
                                    }
                                `}
                            >
                                <input
                                    type="radio"
                                    id={a.id}
                                    name="selected_address"
                                    value={a.id}
                                    onChange={() => handleAddressSelection(a.id)}
                                    className="mt-0.5 accent-[#2f5a2e] flex-shrink-0"
                                />
                                <div className="flex flex-col">
                                    <span className="text-[13px] font-medium text-[#1e2a1a]">
                                        {a.streetName} {a.streetNumber}
                                    </span>
                                    <span className="text-[11px] text-gray-400 mt-0.5">
                                        {a.commune}
                                        {a.houseNumber?.length > 0 && ` · Casa ${a.houseNumber}`}
                                        {a.departmentNumber?.length > 0 && ` · Dpto ${a.departmentNumber}`}
                                    </span>
                                </div>
                            </label>
                        );
                    })}

                    {/* Otra dirección */}
                    <label
                        htmlFor="other"
                        className={`
                            flex items-center gap-3 px-3 py-3 rounded-xl cursor-pointer transition-all border mt-1
                            ${useOtherAddress
                                ? "border-[#4a7c2f] bg-[#edf4e0]"
                                : "border-gray-100 bg-gray-50"
                            }
                        `}
                    >
                        <input
                            type="radio"
                            id="other"
                            name="selected_address"
                            value="other"
                            onChange={() => handleAddressSelection("other")}
                            className="accent-[#2f5a2e] flex-shrink-0"
                        />
                        <span className="text-[13px] font-medium text-[#1e2a1a]">Usar otra dirección</span>
                    </label>
                </div>

                {/* Botón continuar con dirección guardada */}
                {!useOtherAddress && (
                    <div className="px-4 pb-4">
                        <button
                            onClick={handleClickContinue}
                            disabled={!isAddressSelected}
                            className={`
                                w-full py-3 rounded-xl text-sm font-semibold transition-all duration-150
                                ${!isAddressSelected
                                    ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                                    : "bg-[#2f5a2e] hover:bg-[#3f7a3a] active:scale-[0.98] text-[#f4f3e6] shadow-md shadow-[#2f5a2e]/20"
                                }
                            `}
                        >
                            {isAddressSelected ? "Continuar →" : "Selecciona una dirección"}
                        </button>
                    </div>
                )}
            </div>

            {/* Formulario nueva dirección */}
            {useOtherAddress && (
                <div ref={directionFormRef}>
                    <DeliveryForm />
                </div>
            )}
        </div>
    );
}

export default DeliveryMemoryForm;